module.exports = __webpack_public_path__ + "placa_mov_10x_s_1x9_carne.png?b422e69075a01d7456bd9f013d0e5e49";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/placa_mov_10x_s_1x9_carne.png
// module id = 125
// module chunks = 0